import Icon from '../components/Icon.vue'

Icon.register({
  store: {
    width: 616,
    height: 512,
    paths: [
      {
        d: 'M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6C-19.5 172.1 10.2 246.5 72.8 255 77.3 255.6 81.9 255.9 86.5 255.9 116.1 255.9 142.3 242.9 160.3 222.8 178.3 242.9 204.6 255.9 234.1 255.9 263.7 255.9 289.9 242.9 307.9 222.8 325.9 242.9 352.2 255.9 381.7 255.9 411.3 255.9 437.5 242.9 455.5 222.8 473.6 242.9 499.8 255.9 529.3 255.9 534 255.9 538.5 255.6 543 255 605.8 246.6 635.6 172.2 602 118.6zM529.5 288C519.5 288 509.6 286.5 500 284.2V384H116V284.2C106.4 286.4 96.5 288 86.5 288 80.5 288 74.4 287.6 68.5 286.8 62.9 286 57.4 284.7 52.1 283.2V480C52.1 497.7 66.4 512 84.1 512H532.1C549.8 512 564.1 497.7 564.1 480V283.2C558.7 284.8 553.3 286.1 547.7 286.8 541.6 287.6 535.6 288 529.5 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/store.js
// module id = UP2/
// module chunks = 144